import { useContext } from 'react';
import { AreaContext } from 'pages/documents_v2/views/edit_area/context/AreaContext';
import { useGetVariant } from 'pages/documents_v2/hooks/useGetVariant';

export function useGetActiveVariant() {
    const { activeVariantId } = useContext(AreaContext);
    const variant = useGetVariant(activeVariantId);

    return variant;
}
